import React, { useEffect } from 'react';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';
import { useNotificationsContext } from '../../contexts/NotificationsContext';
import './Toast.css';

const ICONS = {
  success: CheckCircle,
  error: AlertCircle,
  info: Info,
  notification: Info
};

const Toast = () => {
  const { toast, clearToast } = useNotificationsContext();

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(clearToast, 4000);
    return () => clearTimeout(timer);
  }, [toast, clearToast]);

  if (!toast) return null;

  const type = toast.type || 'info';
  const Icon = ICONS[type] || Info;
  const message = toast.message || toast;

  return (
    <div className={`titaton-toast titaton-toast-${type}`} role="status" aria-live="polite">
      <Icon size={18} className="titaton-toast-icon" />
      <span className="titaton-toast-msg">{typeof message === 'string' ? message : message.message || ''}</span>
      <button className="titaton-toast-close" onClick={clearToast} aria-label="Fermer">
        <X size={14} />
      </button>
    </div>
  );
};

export default Toast;
